<template>
  <div id="videos" class="mt-5 grey-bg-section">
    <v-row class="pt-5" align="center" justify="center">
      <h1 class="display-2 pt-5">YouTube Videos</h1>
    </v-row>
    <v-row class="mt-2" align="center" justify="center">
      <p class="headline">Check out our YouTube Videos</p>
    </v-row>
    <v-container>
      <v-row class="mt-5" justify="center" align="center">
        <VideoCard
          v-for="video in videos"
          :key="video.id.videoId"
          :video="video"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

import VideoCard from "./VideoCard";
export default {
  components: { VideoCard },
  data() {
    return {
      videos: [],
    };
  },
  async created() {
    let { data } = await axios.get(
      "https://5o1hidfn19.execute-api.us-east-1.amazonaws.com/dev/videos"
    );
    this.videos = data.videos.splice(0, 9);
  },
};
</script>

<style></style>
